import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
// Delete order by ID
 const deleteOrder = async (orderId) => {
  return await apiCall(`${AUTH_ROUTES.ORDER_API_ENDPOINT}/${orderId}`, { method: 'DELETE' });
};

export default deleteOrder;